import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),

  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().corporateReport.paging;
      let { result, status } = await Api.post(
        `project-corporate-reports/filter`,
        {
          pageIndex: pagingData.pageIndex,
          pageSize: pagingData.pageSize,
          search,
          ...filterOption,
          ...sortOption,
        }
      );
      status === 200 && corporateReportDispatcher.getDataSuccess(result);
    },
  sendMail:
    (id, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.post(`project-corporate-reports/${id}/emails`);
      status === 200 && onSuccess();
    },
  getOTP:
    (data, onSuccess) =>
    async ({ Api }) => {
      let { status } = await Api.post(
        `project-corporate-reports/${data.id}/otp`,
        {
          requestKey: data.requestKey,
        }
      );
      status === 200 && onSuccess();
    },
  getAccessLink:
    (id, onSuccess, type = null) =>
    async ({ Api }) => {
      let { result, status } = await Api.get(
        `project-corporate-reports/${id}/access-link${
          type ? `?type=${encodeURIComponent(type)}` : ''
        }`
      );
      status === 200 && onSuccess(result);
    },
};

const corporateReportDispatcher = synthesize(
  'corporateReport',
  mapDispatchToAC
);
export default corporateReportDispatcher;
